// ProductListBlock — візуальний список товарів з діями (+ в кошик)
// + клік по назві відкриває BottomSheet з товаром (через onAction: open_product)

import "../../styles/ProductListBlock.css";

function formatUAH(price) {
  const n = Number(price || 0);

  const formatted = new Intl.NumberFormat("uk-UA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);

  return `₴${formatted}`;
}

export default function ProductListBlock({ block, onAction }) {
  return (
    <div className="block">
      <div className="blockTitle">{block.title || "Товари"}</div>

      {/* горизонтальний скрол (слайдер вправо) */}
      <div className="productsSlider" role="list" aria-label="Товари">
        {block.products?.map((p) => {
          const imgSrc = p.image_proxy_url || p.image_url || "";
          const hasOld =
            p.old_price != null &&
            Number(p.old_price) > 0 &&
            Number(p.price) > 0 &&
            Number(p.old_price) > Number(p.price);

          return (
            <div key={p.id} className="pCard" role="listitem">
              <div className="pImgWrap">
                {imgSrc ? (
                  <img
                    src={imgSrc}
                    alt={p.name || "Product"}
                    loading="lazy"
                    className="pImg"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="pImgFallback">No image</div>
                )}
              </div>

              {/* назва клікабельна (відкриває ProductSheet) */}
              <button
                type="button"
                className="pNameBtn"
                title={p.name}
                onClick={() =>
                  onAction({
  type: "open_product",
  product_id: p.variant_id || p.id,   // ✅ корисно мати variant
  product: p,
})
                }
              >
                {p.name}
              </button>

              <div className="pPriceRow">
                <div className="pPrice">{formatUAH(p.price)}</div>

                {hasOld && (
                  <div className="pOldPrice" aria-label="Стара ціна">
                    {formatUAH(p.old_price)}
                  </div>
                )}
              </div>

              <button
                className="pBtn"
                onClick={() =>
                  onAction({
  type: "add_to_cart",
  product_id: p.variant_id || p.id,   // ✅ POS variant id
  product: {
    ...p,
    id: p.variant_id || p.id,         // ✅ щоб cart зберіг variant як id
  },
  qty: 1,
})
                }
              >
                ДОДАТИ В КОШИК
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}